import { Injectable } from '@angular/core';

export type AuthUser = Record<string, unknown>;

export interface AuthSession {
  user: AuthUser;
  service: string;
  xAuthToken?: string;
  xTnToken?: string;
  createdAt: number;
}

const STORAGE_KEY = 'auth.session.goiania-sso.v1';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  setSession(session: AuthSession): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }

  getSession(): AuthSession | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw) as Partial<AuthSession>;
      if (
        !parsed ||
        typeof parsed !== 'object' ||
        !parsed.user ||
        typeof parsed.user !== 'object' ||
        typeof parsed.service !== 'string' ||
        typeof parsed.createdAt !== 'number'
      ) {
        return null;
      }

      return parsed as AuthSession;
    } catch {
      return null;
    }
  }

  clearSession(): void {
    localStorage.removeItem(STORAGE_KEY);
  }

  isAuthenticated(): boolean {
    return !!this.getSession();
  }
}

